var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmaHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0033 11.5876L14.0003 13.3208L11.0043 11.5923L10.4258 11.9263V12.6153L13.4124 14.3391V17.8077L14.0003 18.1463L14.5882 17.8077V14.3391L17.5912 12.6059V11.9263L17.0033 11.5876Z",
    fill: "#FAE232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.418 7.30462L21.421 9.03777L18.418 10.7733L19.0059 11.1119V11.7915L22.0089 10.056V13.5247L23.1847 12.8451V8.69914L19.5938 6.625L18.418 7.30462Z",
    fill: "#FAE232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9922 6.49157L13.4073 5.09705V6.59033H14.5832V5.09705L16.9983 6.49157L18.1741 5.81194L13.9953 3.39917L9.81641 5.81194L10.9922 6.49157Z",
    fill: "#FAE232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.003 15.1557V17.9447L20.7096 17.1969L20.1217 18.2152L21.4151 18.963L19 20.3552V21.7144L23.1789 19.3016V14.4761L22.003 15.1557Z",
    fill: "#FAE232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89086 12.8874L5.99613 13.5247V10.056L9.01562 11.7986V11.1119L9.59648 10.7756L6.58639 9.03777L9.58942 7.30462L8.41361 6.625L4.82031 8.69914V12.8545C4.84383 12.8639 4.86735 12.8733 4.89086 12.8874Z",
    fill: "#FAE232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5912 21.1699L14.5882 22.9031V19.4368L14.0003 19.7754L13.4124 19.4368V22.9031L10.4258 21.1793V22.5362L14.0003 24.601L17.5912 22.5268V21.1699Z",
    fill: "#FAE232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01562 20.3646L6.58404 18.963L7.87743 18.2152L7.28953 17.1969L5.99613 17.9447V15.1557L4.82031 14.4761V19.3016L9.01562 21.7238V20.3646Z",
    fill: "#FAE232"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2908 19.2063C12.1783 18.6939 12.1954 17.0622 11.3291 15.5618C10.4628 14.0613 9.04117 13.2604 8.15373 13.7727C7.26629 14.2851 7.24913 15.9168 8.11541 17.4172C8.98169 18.9177 10.4034 19.7187 11.2908 19.2063Z",
    fill: "#FAE232"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9073 17.4145C20.7735 15.9141 20.7564 14.2824 19.8689 13.77C18.9815 13.2577 17.5598 14.0586 16.6935 15.5591C15.8273 17.0595 15.8444 18.6912 16.7319 19.2036C17.6193 19.716 19.041 18.915 19.9073 17.4145Z",
    fill: "#FAE232"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 10.8942C15.7329 10.8942 17.1374 10.0635 17.1374 9.03879C17.1374 8.01406 15.7329 7.18335 14.0004 7.18335C12.2678 7.18335 10.8633 8.01406 10.8633 9.03879C10.8633 10.0635 12.2678 10.8942 14.0004 10.8942Z",
    fill: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmaHighlighted);
export default __webpack_public_path__ + "static/media/dma_highlighted.b06baef8b1c484923b974c8c0efe9945.svg";
export { ForwardRef as ReactComponent };